import { Colors } from '../../consts/Colors';
import Obstacle from '../Obstacle';
import { Scales } from '../../consts/Scales';

export default class Poisson6 extends Obstacle {
    constructor(scene, x, y, params = { showHitbox: false }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.type = 'poisson6';
        this.speed = 450;
        this.setPosition(x, y);
        scene.add.existing(this);
    }

    addBody(params) {
        this.texture = this.scene.add.sprite(0, 0, 'poisson6').setOrigin(0.5);
        this.texture.anims.play('poissonAnim6');
        this.add(this.texture);
    }
}
